import type { CheckboxProps } from '@remarkable/ark-web';
import { Checkbox as CheckboxComponent } from '@remarkable/ark-web';
import clsx from 'clsx';

export const Checkbox = ({
  preview,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ref,
  ...props
}: CheckboxProps & {
  preview?: boolean;
}) => (
  <CheckboxComponent
    className={clsx('rounded', { ring: preview })}
    {...props}
  />
);
